import MuiButton from "Components/MuiButton/MuiButton";
import React, { useEffect, useState } from "react";
import showNotify from "../../Helpers/Notify";
import Translator from "Languages/Utility/Translator";
import { useTranslation } from 'react-i18next';
import * as Icons from "react-bootstrap-icons";

function ImageUpload({ object, box_title, button_label, image, onSetImage, maxSize = 500000 }){
  const { t } = useTranslation();
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const _handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let eFile = e.target.files[0];
    if(eFile.size > maxSize) {
      showNotify({
        text: (t('sizeLimitWP')).replace('@P1', maxSize/1000),
        customClass:"error"
      })
      return false;
    }
    reader.onprogress = () => {
      setLoading(true);
    };
    reader.onloadend = () => {
      setLoading(false);
      setImagePreviewUrl(reader.result);
    };
    reader.readAsDataURL(eFile);
  };

  useEffect(() => {
    if (imagePreviewUrl) {
      onSetImage(imagePreviewUrl);
      setImagePreview(<img src={imagePreviewUrl} alt="" />);
    }
  }, [imagePreviewUrl]);

  useEffect(() => {
    if (image) {
      setImagePreview(<img src={`data:image/png;base64, ${image}`} alt="" />);
    } else {
      setImagePreview(<div className="no-item-preview"><Icons.FileEarmarkImage/></div>);
    }
  }, [image]);

  return (
    <div className="image-upload">
      <p className="normalTitle">{t(box_title)}</p>
      <div className="image-container">
        <div className="image-preview">{imagePreview}</div>
        <div className="image-upload-button">
          <input
            accept="image/*"
            className="fileInput"
            type="file"
            onChange={_handleImageChange}
            id={`${object}-contained-button-file`}
            hidden
          />
          <label htmlFor={`${object}-contained-button-file`} className="w-100">
            <MuiButton
              loading={loading}
              color="secondary"
              title={<Translator id={button_label} noSpan />}
              type="submit"
              // size="small"
              component="span"
              className="uploadBtn"
            />
          </label>
        </div>
      </div>
    </div>
  );
};

export default ImageUpload;
